import clsx from 'clsx'
import TextWithIllustrationColumn, {
    TextWithIllustration,
} from '~/components/content/columns/TextWithIllustrationColumn'
import AssuranceColumn, {Assurance} from '~/components/content/columns/AssuranceColumn'

type ColumnItem = Assurance | TextWithIllustration

type ColumnsProps = {
    className?: string
    headline: {
        label: string
        isHidden: boolean
    }
    items: ColumnItem[]
}

const Columns = ({className, headline, items}: ColumnsProps) => {
    const itemType = items[0]._type
    const columnAmount = items.length

    return (
        <div
            className={clsx(
                'mx-auto max-w-screen-xl md:px-6',
                className,
                itemType === 'assurance' && 'px-4'
            )}
        >
            <h2
                className={clsx(
                    headline.isHidden ? 'sr-only' : 'text-2xl mb-4 md:text-4xl font-bold',
                    itemType === 'textWithIllustration' && 'px-4 md:px-0'
                )}
            >
                {headline.label}
            </h2>
            <div
                className={clsx(
                    'grid grid-cols-1 md:grid-cols-2',
                    itemType === 'assurance' ? 'gap-6' : 'gap-x-6 gap-y-8',
                    {
                        'lg:grid-cols-3': columnAmount === 3,
                        'xl:grid-cols-4': columnAmount === 4,
                    }
                )}
            >
                {items.map((item) => {
                    switch (item._type) {
                        case 'assurance':
                            return <AssuranceColumn key={item._key} {...item} />
                        case 'textWithIllustration':
                            return <TextWithIllustrationColumn key={item._key} {...item} />
                        default:
                            return null
                    }
                })}
            </div>
        </div>
    )
}

export default Columns
